import { HttpTypes } from '@/types';
import { IStore } from '@/types/general';
import { IResponse, PartnerAuthorizeShop } from '@/types/http';
import { AxiosInstance } from 'axios';

class IntegrationPartner {
  private client: AxiosInstance;
  private prefix = '/sites';

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async checkState(code: string): Promise<IResponse> {
    const result = await this.client.get(`${this.prefix}/partner/verify?code=${code}`);
    return result.data;
  }

  async getTenantShop(tenantId: string): Promise<IResponse<IStore[]>> {
    const result = await this.client.get(`${this.prefix}/partner/shop/list?code=${tenantId}`);
    return result.data;
  }

  async authorizeShop(
    data: PartnerAuthorizeShop
  ): Promise<IResponse<HttpTypes.PartnerAuthorizeShopResponse>> {
    const result = await this.client.post(
      `${this.prefix}/partner/shop/authorize?code=${data.code}`,
      {
        store_id: data.store_id,
        is_acknowledged: data.is_acknowledged,
        authorization: data.authorization,
      }
    );
    return result.data;
  }
}

export default IntegrationPartner;
